import { JobState } from "@/lib/jobState";

/**
 * Header tooltips for the two Dispatch tables.
 *
 * Kept in one module rather than inline in the column defs so the copy is
 * reviewable in one place -- and so it stays honest. Each string describes
 * what `deriveJobState` actually buckets and what `getJobHours` actually
 * sums, so a change to either belongs in the same commit as a change here.
 */
export const JOB_STATE_TOOLTIPS: Record<JobState, string> = {
  pending:
    "Jobs the customer has not answered yet — the job has no authorization date. Hours are the labor estimate.",
  approved:
    "Authorized by the customer but not finished yet. Hours are the labor estimate. This is the figure the amber capacity highlight and the summary tiles above are based on.",
  completed:
    "Jobs with a completion date. Hours are the time actually logged, falling back to the labor estimate when nothing was clocked.",
  declined: "The customer was asked and said no. Hours are the labor estimate.",
};

export const TECHNICIAN_COLUMN_TOOLTIP =
  "Everyone on the shop's roster. Click a row to see that person's individual jobs.";

/**
 * The heading's info-icon copy. Names the shop setting verbatim as it reads
 * in Shop Settings ("Use Shop Hero Employee Job Title") so someone can go
 * find the toggle by the label they see here.
 */
export const TECHNICIAN_HOURS_HEADING_TOOLTIP =
  'Hours cover cards on every board, not just the one you are viewing. The list includes every employee — turn on "Use Shop Hero Employee Job Title" in Shop Settings to narrow it to technicians.';

export const JOB_DETAIL_COLUMN_TOOLTIPS = {
  cardNumber: "The repair order this job belongs to.",
  jobName:
    "Job name from the repair order. Cards with no itemized jobs show a dash.",
  state:
    "Pending, Approved, Completed or Declined — the same buckets as the Technician Hours table.",
  hours:
    "Time actually logged for completed jobs; the labor estimate for everything else.",
} as const;
